(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-register"]) return;
  try {
    
  (function() {
    const urlParams = new URLSearchParams(window.location.search);
    const utmCampaign = urlParams.get('utm_campaign');
    
    if (utmCampaign === 'Klaviyo') {
      const form = document.getElementById('create_customer');
      if (form) {
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'customer[tags]';
        hiddenInput.value = 'channel_klaviyo';
        form.appendChild(hiddenInput);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
